export const workingTimeList = [
  // {
  //   id: 0.0,
  //   name: "0.0",
  // },
  {
    id: 0.5,
    name: "0.5",
  },
  {
    id: 1.0,
    name: "1.0",
  },
  {
    id: 1.5,
    name: "1.5",
  },
  {
    id: 2.0,
    name: "2.0",
  },
  {
    id: 2.5,
    name: "2.5",
  },
  {
    id: 3.0,
    name: "3.0",
  },
  {
    id: 3.5,
    name: "3.5",
  },
  {
    id: 4.0,
    name: "4.0",
  },
  {
    id: 4.5,
    name: "4.5",
  },
  {
    id: 5.0,
    name: "5.0",
  },
  {
    id: 5.5,
    name: "5.5",
  },
  {
    id: 6.0,
    name: "6.0",
  },
  {
    id: 6.5,
    name: "6.5",
  },
  {
    id: 7.0,
    name: "7.0",
  },
  {
    id: 7.5,
    name: "7.5",
  },
  {
    id: 8.0,
    name: "8.0",
  },
];
